// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Global from '@/global'
import animate from 'animate.css'
import MetaInfo from 'vue-meta-info'
import 'babel-polyfill'
Vue.use(MetaInfo)
import $ from "jquery";
import VueLazyload from 'vue-lazyload'
	Vue.use(VueLazyload, {
		preLoad: 1.3,
		error: '',
		loading: '',
		attempt: 1
	})
Vue.config.productionTip = false
Vue.prototype.GLOBAL = Global
Vue.use(animate)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
    mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js